import { useCallback, useEffect, useState } from 'react';
import { ActionDependant } from '@ea-lab/reactive-json';
import { Maximize2, Minimize2 } from 'lucide-react';

const STORAGE_KEY = 'orbit-doc-wide-mode';
const EVENT_NAME = 'doc:toggle-wide-mode';

export const DocWideModeButton = ({ props }) => {
    const [wide, setWide] = useState(() => {
        try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch { return false; }
    });

    useEffect(() => {
        const handler = () => {
            try { setWide(localStorage.getItem(STORAGE_KEY) === '1'); } catch {}
        };
        window.addEventListener(EVENT_NAME, handler);
        return () => window.removeEventListener(EVENT_NAME, handler);
    }, []);

    const handleClick = useCallback(() => {
        const next = !wide;
        try { localStorage.setItem(STORAGE_KEY, next ? '1' : '0'); } catch {}
        setWide(next);
        window.dispatchEvent(new CustomEvent(EVENT_NAME));
    }, [wide]);

    return (
        <ActionDependant {...props}>
            <button
                type="button"
                onClick={handleClick}
                className="inline-flex items-center justify-center w-8 h-8 rounded-lg text-stone-400 hover:text-stone-600 hover:bg-stone-100 transition-colors"
                title={wide ? 'Mode normal' : 'Mode élargi'}
                aria-label={wide ? 'Passer en mode normal' : 'Passer en mode élargi'}
            >
                {wide ? <Minimize2 size={15} /> : <Maximize2 size={15} />}
            </button>
        </ActionDependant>
    );
};
